<template>
  <label :for="context.id">
    {{ context.label }}
    <span v-if="isRequired" class="field-required" aria-hidden="true">*</span>
  </label>
</template>

<script>
export default {
  name: "FormLabel",
  props: {
    context: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isRequired() {
      return (
        this.context.validationErrors.filter(
          (msg) => msg.includes("is required") || msg.includes("Pflichtfeld")
        ).length > 0 || this.context.classification === "select" //TODO all selects are marked as required, required validation doesnt work with selects?
      );
    },
  },
};
</script>
